<template>
    <div>
        <v-container style="max-width:1000px">
            <h1 style="text-align:center">Välj datum</h1>
            <v-container>
                <v-row>
                    <v-col>
                        <v-date-picker
                            v-model="date"
                            first-day-of-week="1"
                            locale="sv"
                            :show-current="true"
                            :min="
                                nowDate
                            "
                        >
                        </v-date-picker
                        ><br />
                    </v-col>
                    <v-col>
                        <v-container v-for="(date, i) in dates" :key="i">
                            <v-row>
                                <div class="daybox">
                                    <p class="month">{{ toMonth(date['date']) }}</p>
                                    <p class="day">{{ toDay(date['date']) }}</p>
                                </div>
                                <div>
                                <div class="selectbox">
                                    <v-select
                                    v-model="stime[date['id']]"
                                    :items="items"
                                    :item-text="'05:30'"
                                    label="Starttid"
                                    @input="setTime(date['date'], date['id'])"
                                    ></v-select>
                                    <v-select
                                    v-model="ftime[date['id']]"
                                    :items="items"
                                    label="Sluttid"
                                    v-if="stime[date['id']] === undefined"
                                    disabled
                                    @input="setTime(date['date'], date['id'])"
                                    ></v-select>
                                    <v-select
                                    v-else
                                    v-model="ftime[date['id']]"
                                    :items="items"
                                    label="Sluttid"
                                    @input="setTime(date['date'], date['id'])"
                                    ></v-select>
                                    <v-btn @click="removeDate(i,date['id'])" text
                                    ><v-icon small color="red">fas fa-trash</v-icon></v-btn>
                                </div>
                                <div class="addbtn">
                                    <v-btn
                                    v-show="dates.indexOf(dates[i]) == i"
                                    @click="add(date['date'])"
                                    text
                                    small
                                    >Lägg till tid</v-btn></div>
                                    </div>
                            
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <div>
                    <v-row
                        ><v-switch
                        :false-value="'no'" :true-value="'yes'"
                            v-model="schedule.reply_deadline"
                            label="Sätt en deadline för svar"/>
                            
                        <v-col cols="12" sm="6" md="4">
                        <v-menu
        v-model="menu2s"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="schedule.reply_deadline_date"
            readonly
            v-bind="attrs"
            v-on="on"
        v-show="schedule.reply_deadline=='yes'"
          ></v-text-field>
        </template>
        <v-date-picker v-model="schedule.reply_deadline_date" locale="sv" 
            first-day-of-week="1" :min="nowDate" @input="menu2s = false"></v-date-picker>
      </v-menu>
      </v-col>
                    </v-row>
                    <v-row>
                        <v-switch
                        :false-value="'no'" :true-value="'yes'"
                            v-model="schedule.if_needed_option"
                            label="Lägg till
                        alternativet 'Om det behövs' för att fånga upp även
                        halvbra tidsförslag."
                        />
                    </v-row>
                    <v-row>
                        <!-- <v-checkbox
                        :false-value="'no'" :true-value="'yes'"
                            v-model="schedule.one_answer"
                            label="Begränsa till ett svar"
                        /> -->
                        <v-checkbox
                        :false-value="'no'" :true-value="'yes'"
                         v-model="schedule.hidden_schedule" label="Dölj deltagarnamn (endast du som skapat omröstningen kommer att kunna se dem)" />
                    </v-row>
                    <v-row>
                        <v-checkbox
                        :false-value="'no'" :true-value="'yes'"
                            v-model="schedule.ask_for_contact"
                            label="Be om kontaktinformation"
                        />
                    </v-row>
                    <v-row v-if="schedule.ask_for_contact=='yes'">
                        <v-checkbox
                            label="E-post"
                            readonly
                            v-model="echeck"
                        />
                        <v-checkbox
                            label="Mobil"
                            readonly
                            v-model="pcheck"
                        />
                        </v-row>
                    <v-row v-if="schedule.ask_for_contact=='yes'" class="contact">
                        <v-text-field label="Annan valfri information 1" v-model="schedule.contact_info1" />
                        <v-text-field label="Annan valfri information 2" v-model="schedule.contact_info2" />
                        <v-text-field label="Annan valfri information 3" v-model="schedule.contact_info3" />
                        <v-text-field label="Annan valfri information 4" v-model="schedule.contact_info4" />
                        <v-text-field label="Annan valfri information 5" v-model="schedule.contact_info5" />
                    </v-row>
                    
                </div>
                <v-btn @click="submit" style="background-color:#ffa500"
                    >Skicka in
                    <v-icon style="font-size:15px;margin-left:3px"
                        >fas fa-check</v-icon
                    ></v-btn
                >
            </v-container>
            <v-dialog v-model="adddialog" width="500">
                <v-alert>
                    Tiden har lagts till
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="adddialog = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
            <v-dialog v-model="rmdialog" width="500">
                <v-alert>
                    Tid borttagen
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="rmdialog = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
            <v-dialog v-model="addtime" width="500">
                <v-alert>
                    Du måste välja minst ett datum och tidpunkt.
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="addtime = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import store from "../../store";
import axios from "axios";
export default {
    data: () => ({
        store: store,
        name: "Step2",
        dateNow: "",
        date: null,
        month: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
        items: ['00:00', '00:15', '00:30', '00:45','01:00', '01:15', '01:30', '01:45','02:00', '02:15', '02:30', '02:45',
        '03:00', '03:15', '03:30', '03:45','04:00', '04:15', '04:30', '04:45','05:00', '05:15', '05:30', '05:45',
        '06:00', '06:15', '06:30', '06:45','07:00', '07:15', '07:30', '07:45','08:00', '08:15', '08:30', '08:45',
        '09:00', '09:15', '09:30', '09:45','10:00', '10:15', '10:30', '10:45','11:00', '11:15', '11:30', '11:45',
        '12:00', '12:15', '12:30', '12:45','13:00', '13:15', '13:30', '13:45','14:00', '14:15', '14:30', '14:45',
        '15:00', '15:15', '15:30', '15:45','16:00', '16:15', '16:30', '16:45','17:00', '17:15', '17:30', '17:45',
        '18:00', '18:15', '18:30', '18:45','19:00', '19:15', '19:30', '19:45','20:00','20:15', '20:30', '20:45',
        '21:00','21:15', '21:30', '21:45','22:00', '22:15', '22:30', '22:45','23:00', '23:15', '23:30', '23:45'],
        itemss:[{id:'0',text:'00:00'}, {id:'1',text:'00:15'}, {id:'2',text:'00:30'}, {id:'3',text:'00:45'},{id:'4',text:'01:00'},
                {id:'5',text:'01:15'}, {id:'6',text:'01:30'}, {id:'7',text:'01:45'},{id:'8',text:'02:00'}, {id:'9',text:'02:15'},
                {id:'10',text: '02:30'}, {id:'11',text:'02:45'},{id:'12',text: '03:00'},{id:'13',text: '03:15'},{id:'14',text: '03:30'},
                {id:'15',text:'03:45'},{id:'16',text:'04:00'}, {id:'17',text:'04:15'}, {id:'18',text:'04:30'}, {id:'19',text:'04:45'},{id:'20',text:'05:00'},
                {id:'21',text: '05:15'},{id:'22',text: '05:30'}, {id:'23',text:'05:45'},{id:'24',text:'06:00'}, {id:'25',text:'06:15'},
                {id:'26',text:'06:30'}, {id:'27',text:'06:45'},{id:'28',text:'07:00'}, {id:'29',text:'07:15'},{id:'30',text: '07:30'},
                {id:'31',text: '07:45'},{id:'32',text:'08:00'}, {id:'33',text:'08:15'},{id:'34',text: '08:30'}, {id:'35',text:'08:45'},
                {id:'36',text: '09:00'},{id:'37',text: '09:15'},{id:'38',text: '09:30'}, {id:'39',text:'09:45'},{id:'40',text:'10:00'},
                {id:'41',text:'10:15'}, {id:'42',text:'10:30'},{id:'43',text: '10:45'},{id:'44',text:'11:00'}, {id:'45',text:'11:15'},
                {id:'46',text:'11:30'},{id:'47',text: '11:45'},{id:'48',text:'12:00'}, {id:'49',text:'12:15'},{id:'50',text: '12:30'},
                {id:'51',text: '12:45'},{id:'52',text:'13:00'}, {id:'53',text:'13:15'},{id:'54',text: '13:30'},{id:'55',text: '13:45'},
                {id:'56',text:'14:00'},{id:'57',text: '14:15'},{id:'58',text: '14:30'},{id:'59',text: '14:45'},{id:'60',text: '15:00'},
                {id:'61',text: '15:15'}, {id:'62',text:'15:30'}, {id:'63',text:'15:45'},{id:'64',text:'16:00'}, {id:'65',text:'16:15'},
                {id:'66',text: '16:30'}, {id:'67',text:'16:45'},{id:'68',text:'17:00'}, {id:'69',text:'17:15'}, {id:'70',text:'17:30'},
                {id:'71',text:'17:45'},{id:'72',text:'18:00'}, {id:'73',text:'18:15'}, {id:'74',text:'18:30'}, {id:'75',text:'18:45'},
                {id:'76',text:'19:00'}, {id:'77',text:'19:15'}, {id:'78',text:'19:30'}, {id:'79',text:'19:45'},{id:'80',text:'20:00'},
                {id:'81',text:'20:15'}, {id:'82',text:'20:30'},{id:'83',text: '20:45'},{id:'84',text:'21:00'},{id:'85',text:'21:15'},
                {id:'86',text:'21:30'}, {id:'87',text:'21:45'},{id:'88',text:'22:00'}, {id:'89',text:'22:15'}, {id:'90',text:'22:30'},
                {id:'91',text: '22:45'},{id:'92',text:'23:00'},{id:'93',text:'23:15'},{id:'94',text: '23:30'}, {id:'95',text:'23:45'}],
        dates: [],
        schdates: [],
        schedule: [],
        time: [],
        times: [],
        menu: [],
        stime: [],
        ftime: [],
        menu2: [],
        menu2s: false,
        adddialog: false,
        rmdialog: false,
        addtime: false,
        echeck: true,
        pcheck: true,
        replyDeadline: store.state.schedule.replyDeadline,
        ifNeeded: store.state.schedule.ifNeeded,
        oneAns: store.state.schedule.oneAns,
        hidSchedule: store.state.schedule.hidSchedule,
        contactInfo: store.state.schedule.contactInfo,
        adminOnly: store.state.schedule.adminOnly,
        config: {},
        replyDate: store.state.schedule.replyDate,
        disabledDates: new Date(Date.now() - 8640000),
        nowDate: new Date().toISOString().slice(0,10),
        ci0: undefined,
        ci1: undefined,
        ci2: undefined,
        ci3: undefined
    }),
    watch: {
        date: function() {
            this.add(this.date);
            // console.log(val);
        }
    },
    created: async function() {
        let date = new Date();
        this.dateNow = `${date.getFullYear()}-0${date.getMonth()}-${date.getDate()}`;
        this.id= this.$route.params.id
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}getschema/${this.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data.schedule;
        this.schdates = resp.data.dates
        for (let i = 0; i < this.schdates.length; i++) {
            this.dates.push({
                id: i,
                date:this.schdates[i].schedule_date,
                stime:this.schdates[i].time_from,
                ftime:this.schdates[i].time_to
            });
            this.store.state.schedule.time = this.dates
            // this.stime.push(this.schdates[i].time_from);
            // this.ftime.push(this.schdates[i].time_to);
            this.stime[i] = this.toMMHH(this.schdates[i].time_from)
            this.ftime[i] = this.toMMHH(this.schdates[i].time_to)
            // this.stime[i] = '04:00'
        }
            this.dates.sort((a, b) => new Date(a['date']) - new Date(b['date']))
            
            console.log(this.store.state.schedule.time)

    },
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.replyDate)
      },
    },
    methods: {
        allowedMinutes: v => v % 5 == 0,
        next: async function() {
            this.config = {
                schedule: this.store.state.schedule.time,
                replyDeadline: this.replyDeadline,
                ifNeeded: this.ifNeeded,
                oneAns: this.oneAns,
                hidSchedule: this.hidSchedule,
                contactInfo: this.contactInfo,
                adminOnly: this.adminOnly,
                replyDate: this.replyDate,
                ci0: this.ci0,
                ci1: this.ci1,
                ci2: this.ci2,
                ci3: this.ci3,
                ci4: this.ci4
            };
            if (this.dates.length === 0) {
                this.store.state.alertMsg = "Du måste välja minst en tidpunkt.";
                this.store.state.showAlert = true;
                this.store.state.alertType = "error";
                return;
            }
            await this.store.dispatch("step2", this.config);
            this.store.state.e1++;
        },
        add: function(date) {
            if (date === null) return;
            let dat = {id:this.dates.length, date:date, stime: "00:00:00", ftime: "00:00:00" }
            // this.dates[this.dates.length] = date;
            this.dates[this.dates.length] = dat;
            this.dates.sort((a, b) => new Date(a['date']) - new Date(b['date']))
            // let j = this.store.state.schedule.time.length;
            // let datee = {
            //     id: j,
            //     date: date,
            //     stime: '',
            //     ftime: ''
            // };
            
            // this.store.state.schedule.time[j] = datee; 
            this.$forceUpdate()
            // this.menu[this.dates.length] = false;
            // this.menu2.push(false);
            console.log(this.store.state.schedule.time)
        },
        setTime: function(indate, i) {
            // let date = {
            //     date: indate,
            //     stime: this.stime[i],
            //     ftime: this.ftime[i]
            // };
            // let j = this.store.state.schedule.time.length;
            // this.store.state.schedule.time[j] = date;
            let array = this.store.state.schedule.time
            let item = array.find(x => x.id == i);
            if (item) {
            item.stime = this.stime[i];
            item.ftime = this.ftime[i];
            if(this.ftime[i] === undefined){
                item.ftime = '';
            }
            } else {
               let date = {
                id: i,
                date: indate,
                stime: this.stime[i],
                ftime: this.ftime[i]
            };
            let j = this.store.state.schedule.time.length;
            this.store.state.schedule.time[j] = date; 
            }
            console.log(this.store.state.schedule.time)
            // alert(this.stime[i])
            // alert(this.ftime[i])
            // if(){
            //     return
            // }
            // this.adddialog = true;
        },
        removeDate: function(i,date) {
            // this.dates.splice(i, 1);
            this.dates.splice(date, 1);
            // this.store.state.schedule.time.splice(date, 1);
            this.menu2.splice(date);
            // console.log(this.store.state.schedule.time)
            // this.rmdialog = true;
        },
        back: function() {
            this.store.state.e1--;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toMMHH(time) {
            return time.substring(0, 5);
        },
        toDay(date) {
            let dated = new Date(date);
            return `${dated.getDate()}`;
        },
        toMonth(date) {
            let dated = new Date(date);
            return `${this.month[dated.getMonth()]}`;
        },
        submit: async function() {
            if (this.dates.length === 0) {
                this.store.state.alertMsg = "Du måste välja minst en tidpunkt.";
                this.store.state.alertType = "error";
                this.store.state.showAlert = true;
                this.addtime = true;
                return;
            }
            // else if(this.ftime.length === 0){
            //     this.addtime = true;
            //     return;
            // }
            if(this.store.state.schedule.time.length === 0){
                this.store.state.schedule.time = this.dates
            }
            // this.store.state.loading = true;
            // this.config = {
            //     id: this.schedule.id,
            //     schedule: this.store.state.schedule.time,
            //     replyDeadline: this.schedule.reply_deadline,
            //     ifNeeded: this.schedule.if_needed_option,
            //     oneAns: this.schedule.one_answer,
            //     hidSchedule: this.schedule.hidden_schedule,
            //     contactInfo: this.schedule.ask_for_contact,
            //     replyDate: this.schedule.reply_deadline_date,
            //     ci0: this.schedule.contact_info1,
            //     ci1: this.schedule.contact_info2,
            //     ci2: this.schedule.contact_info3,
            //     ci3: this.schedule.contact_info4,
            //     ci4: this.schedule.contact_info5
            // };
            // await this.store.dispatch("step2", this.config);
            let bodyFormData = new FormData();
            bodyFormData.append("id", this.schedule.id);
            bodyFormData.append(
                "time",
                JSON.stringify(this.store.state.schedule.time)
            );
                bodyFormData.append("ifNeeded", this.schedule.if_needed_option);
                bodyFormData.append("deadlineReply", this.schedule.reply_deadline);
                bodyFormData.append(
                    "deadlineDate",
                    this.schedule.reply_deadline_date
                );

                bodyFormData.append("oneAns", this.schedule.one_answer);
                bodyFormData.append("hidSchedule", this.schedule.hidden_schedule);
                bodyFormData.append("contactInfo", this.schedule.ask_for_contact);
            bodyFormData.append("ci0", this.schedule.contact_info1);
            bodyFormData.append("ci1", this.schedule.contact_info2);
            bodyFormData.append("ci2", this.schedule.contact_info3);
            bodyFormData.append("ci3", this.schedule.contact_info4);
            bodyFormData.append("ci4", this.schedule.contact_info5);
            var config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            config.url = `${this.store.state.baseURL}editevent`;
            await axios(config);
            this.$router.replace("/schedule/"+ this.schedule.schedule_link);
        },
        formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }
    }
};
</script>

<style scopped>
.input {
    margin-left: 10px;
    max-height: 40px;
    margin-top: 10px;
    border: 2px solid black;
}
.inputtime {
    margin-left: 10px;
    max-height: 45px;
    border: 2px solid black;
}
.daybox {
    background-color: #ffa500;
    border-radius: 6px;
    padding: 0px 10px;
    text-align: center;
    color: #fff;
    height: 75px;
}
.day {
    margin: 5px 0px !important;
    font-weight: 700 !important;
    font-size: 1.25rem !important;
}
.month {
    margin: 5px 0px !important;
}
.selectbox {
    display: flex;
    justify-content: flex-start;
    margin: 0px 20px;
}
.selectbox .v-input {
    width: 100px !important;
}
.addbtn {
    margin: 0px 40px;
}
.contact {
    display: block;
}
</style>
